
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hotels/news/[id]",
      function () {
        return require("private-next-pages/hotels/news/[id].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hotels/news/[id]"])
      });
    }
  